import Decimal from './break_infinity';
import {LitElement} from 'lit';
import {property} from 'lit/decorators.js';
import './htmlelement-tag-name-map';
import {ri} from './runner-idle';
import {activitiesByTag} from './utils';

export class UnlockableLitElement extends LitElement {
  @property() name = 'unlockable';
  @property() displayName = 'Unlockable';
  // Tags get merged upon assignment, to allow for Object.assign updating
  // I should probably just manually do tags.add(newtag) instead
  protected _tags: Set<string> = new Set();
  set tags(val) {
    this._tags = new Set([...val, ...this._tags]);
  }
  get tags() {
    return this._tags;
  }
  @property({type: Boolean}) unlocked = false;
  get new() {
    return this.classList.contains('new');
  }
  set new(value) {
    this.classList.toggle('new', value);
  }

  @property() conditionString = 'Unlocked at start.';
  @property({type: Function}) condition = () => true;
  @property({type: Function}) visibleCondition = () => true;
  _progress = () => new Decimal(0);
  get progress() {
    return () => new Decimal((this.unlocked ? 1 : 0) || this._progress());
  }
  set progress(value) {
    this._progress = value;
  }
  _visible = false;
  get visible() {
    if (this._visible) return true;
    this._visible = this.visibleCondition();
    return this._visible;
  }
  @property({type: Boolean}) secret = false;
  @property({type: Boolean}) hiddenByPlayer = false;
  persistentUnlock = false;
  persistentValue = false;
  setInitials() {}
  resetToInitials() {}

  constructor() {
    super();
    this.addEventListener('mouseover', () => {
      this.new = false;
      ri.requestUpdate();
    });
  }

  public tryUnlock(cheat = false) {
    // Only unlock once
    if (this.unlocked) return false;
    if (this.condition() || cheat) {
      this.unlocked = true;
      this.hidden = false;
      this.new = true;
      this.secret = false;
      this.onUnlock();
      Object.values(ri.activities)
        .filter((activity) => activity.options.includes(this.name))
        .forEach((activity) => activity.requestUpdate());
      Object.values(ri.spells)
        .filter((spell) => spell.options.includes(this.name))
        .forEach((spell) => spell.requestUpdate());
      return true;
    }
    return false;
  }
  onUnlock = () => {};
}
